import { render, staticRenderFns } from "./FTPDataModal.vue?vue&type=template&id=6bb5fcd6&"
import script from "./FTPDataModal.vue?vue&type=script&lang=js&"
export * from "./FTPDataModal.vue?vue&type=script&lang=js&"
import style0 from "./FTPDataModal.vue?vue&type=style&index=0&id=6bb5fcd6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports